import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, from } from "rxjs";
import { catchError, take } from "rxjs/operators";
import { IStatus } from "../models/lookup.model";
import {
  environment,
  BuildEnvironment
} from "../../../environments/environment";
import { map } from "rxjs-compat/operator/map";

interface CountryLookup {
  Name: string;
  Code: string;
}
@Injectable({
  providedIn: "root"
})
export class LookupsService {
  //"https://serverjanv1.azurewebsites.net/public/controllers/api";

  constructor(private http: HttpClient) {}

  //var tableArray:string[] = ['status','priority','country','province'];
  /*
   *---Note tablename should be one of the array elements above---//
   */
  getLookupByTableAlias(tablename : any ): Observable<IStatus> {
    let rootURL = environment.apiConfig.apiUrl;

    return this.http.get<IStatus>(rootURL + "/lookups/tables/" + tablename);
  }
}
